import type { AddressbookTranslations } from './types'

/**
 * Urdu translations for Addressbook domain
 */
export const urTranslations: AddressbookTranslations = {
  // Page/Section level
  title: "ایڈریس بک",
  subtitle: "اپنے مقامات اور پتوں کا انتظام کریں",

  // Actions
  addAddress: "نیا پتہ شامل کریں",
  editAddress: "پتہ ترمیم کریں",
  deleteAddress: "پتہ حذف کریں",
  exportComingSoon: "ایکسپورٹ فیچر جلد دستیاب ہوگا۔",

  // Drawer Headers
  addAddressDescription: "نیا پتہ شامل کرنے کے لیے تفصیلات بھریں",
  editAddressDescription: "نیچے دی گئی پتے کی تفصیلات اپ ڈیٹ کریں",

  // Section Headers
  basicInfo: "بنیادی معلومات",
  addressDetails: "پتے کی تفصیلات",
  contactInfo: "رابطے کی معلومات",
  coordinates: "نقاط",

  // Search and states
  searchPlaceholder: "پتے تلاش کریں...",
  noAddresses: "کوئی پتہ نہیں ملا",
  noAddressesDescription: "آپ نے ابھی تک کوئی پتہ شامل نہیں کیا۔ شروع کرنے کے لیے اپنا پہلا پتہ شامل کریں۔",
  addFirst: "اپنا پہلا پتہ شامل کریں",

  // Form fields
  locationName: "مقام کا نام",
  locationNamePlaceholder: "مثلاً مرکزی دفتر، گودام اے",
  locationType: "مقام کی قسم",
  selectType: "مقام کی قسم منتخب کریں",
  selectLocationType: "مقام کی قسم منتخب کریں (اختیاری)",
  noLocationType: "کوئی مقام کی قسم نہیں",
  streetAddress: "گلی کا پتہ",
  streetAddressPlaceholder: "گلی کا پتہ، عمارت کا نام وغیرہ درج کریں",
  region: "علاقہ",
  selectRegion: "علاقہ منتخب کریں",
  city: "شہر",
  selectCity: "شہر منتخب کریں",
  selectRegionFirst: "پہلے علاقہ منتخب کریں",
  country: "ملک",
  selectCountry: "ملک منتخب کریں",
  selectCountryFirst: "پہلے ملک منتخب کریں",
  noCitiesAvailable: "کوئی شہر دستیاب نہیں",
  postalCode: "ڈاک کوڈ",
  postalCodePlaceholder: "ڈاک کوڈ درج کریں",
  latitude: "عرض البلد",
  longitude: "طول البلد",
  contactName: "رابطہ نام",
  contactNamePlaceholder: "رابطہ شخص کا نام درج کریں",
  contactPhone: "رابطہ فون",
  contactPhonePlaceholder: "+966 50 XXX XXXX",
  contactEmail: "رابطہ ای میل",
  address: "پتہ",
  notes: "نوٹس",
  tags: "ٹیگز",
  timezone: "ٹائم زون",

  // Address Types
  site: "سائٹ",
  office: "دفتر",
  warehouse: "گودام",
  home: "گھر",
  plant: "پلانٹ",
  customer: "گاہک",

  // Status
  defaultAddress: "ڈیفالٹ پتہ",
  favorite: "پسندیدہ",

  // Toast Messages
  addressCreated: "پتہ بنایا گیا",
  addressCreatedDescription: "نیا پتہ کامیابی سے شامل ہو گیا ہے۔",
  addressUpdated: "پتہ اپ ڈیٹ ہوا",
  addressUpdatedDescription: "پتے کی تفصیلات اپ ڈیٹ ہو گئی ہیں۔",
  addressDeleted: "پتہ حذف ہوا",
  addressDeletedDescription: "پتہ ہٹا دیا گیا ہے۔",

  // Delete Dialog
  deleteTitle: "پتہ حذف کریں",
  deleteDescription: "کیا آپ واقعی اس پتے کو حذف کرنا چاہتے ہیں؟ یہ عمل واپس نہیں ہو سکتا۔",
  deleteConfirm: "ہاں، حذف کریں",

  // Filter Options
  filterAll: "تمام اقسام",
  filterSite: "سائٹس",
  filterOffice: "دفاتر",
  filterWarehouse: "گودام",
  filterHome: "گھر",
  filterPlant: "پلانٹس",
  filterCustomer: "گاہکین",

  // Stats
  totalAddresses: "کل پتے",
  activeAddresses: "فعال",
  inactiveAddresses: "غیر فعال",

  // Table Headers
  table: {
    name: "نام",
    type: "قسم",
    address: "پتہ",
    city: "شہر",
    contact: "رابطہ",
    status: "حالت"
  },

  // Contact Types
  contactType: {
    gate_manager: "گیٹ مینیجر",
    dock_supervisor: "ڈاک سپروائزر",
    security: "سیکیورٹی",
    primary_contact: "بنیادی رابطہ",
    emergency_contact: "ہنگامی رابطہ"
  },

  // Location Type descriptions (extended)
  locationTypeDescriptions: {
    site: "تعمیراتی سائٹ",
    office: "دفتری عمارت",
    warehouse: "گودام",
    home: "گھر کا پتہ",
    plant: "مینوفیکچرنگ پلانٹ",
    customer: "گاہک کا مقام"
  },

  // Validation
  validation: {
    nameRequired: "مقام کا نام ضروری ہے",
    addressRequired: "گلی کا پتہ ضروری ہے",
    countryRequired: "ملک ضروری ہے",
    cityRequired: "شہر ضروری ہے"
  },

  // Additional Form
  form: {
    englishSection: "انگریزی",
    streetSection: "گلی کا پتہ",
    locationNameEn: "مقام کا نام (انگریزی)",
    locationNameAr: "مقام کا نام (عربی)",
    locationNameArPlaceholder: "عربی نام (اختیاری)",
    streetAddressEn: "گلی کا پتہ (انگریزی)",
    streetAddressAr: "گلی کا پتہ (عربی)",
    streetAddressArPlaceholder: "عربی میں گلی کا پتہ (اختیاری)",
    addressLine2: "پتہ لائن 2",
    addressLine2Placeholder: "اپارٹمنٹ، سویٹ، یونٹ وغیرہ (اختیاری)",
    addressLine2En: "پتہ لائن 2 (انگریزی)",
    addressLine2Ar: "پتہ لائن 2 (عربی)",
    addressLine2ArPlaceholder: "لائن 2 عربی میں (اختیاری)",
  },

  // Additional keys
  addressId: "پتہ آئی ڈی",
  createNewLocation: "نیا مقام بنائیں",
  createNewLocationHint: "نیا ڈیلیوری پتہ شامل کریں",
  searchLocations: "مقامات تلاش کریں...",
  noMatchingAddresses: "کوئی مماثل پتہ نہیں",
  noAddressesFound: "کوئی پتہ نہیں ملا",

  // Widget/Stats keys
  locations: "مقامات",
  sites: "سائٹس",
  offices: "دفاتر",
  total: "کل",
  active: "فعال",
  inactive: "غیر فعال",

  // Table column keys
  name: "نام",
  actions: "اعمال",

  // Delete confirmation with placeholder
  deleteConfirmation: "کیا آپ واقعی {{name}} کو حذف کرنا چاہتے ہیں؟ یہ عمل واپس نہیں ہو سکتا۔",

  // Standalone convenience keys (duplicates of nested keys for easier access)
  type: "قسم",
  contact: "رابطہ",
  status: "حیثیت",

  // Contact type standalone keys (duplicates of contactType for easier access)
  gate_manager: "گیٹ مینیجر",
  dock_supervisor: "ڈاک سپروائزر",
  security: "سیکیورٹی",
  primary_contact: "بنیادی رابطہ",
  emergency_contact: "ہنگامی رابطہ",

  // Validation standalone keys (duplicates of validation for easier access)
  nameRequired: "مقام کا نام ضروری ہے",
  addressRequired: "گلی کا پتہ ضروری ہے",
  countryRequired: "ملک ضروری ہے",
  cityRequired: "شہر ضروری ہے",

  // Form standalone keys (duplicates of form for easier access)
  addressLine2: "پتہ لائن 2",
  addressLine2Placeholder: "اپارٹمنٹ، سویٹ، یونٹ وغیرہ (اختیاری)",
}
